import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { ICON_NAMES } from '../../../../../../../../constants'
import Icon from '../../../../../../../atoms/Icon'
import SydInput from '../../../../../../../commonDesign/SydInput'

const allIconNames = Object.values(ICON_NAMES)

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
    gap: '4px',
    maxHeight: '260px',
    overflowY: 'auto',
    border: '1px solid var(--border-color)',
    borderRadius: 'var(--border-radius-md)',
    padding: '8px'
  },
  cell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    padding: '8px 4px',
    borderRadius: 'var(--border-radius-sm)',
    cursor: 'pointer',
    transition: 'background 0.15s',
    '&:hover': {
      background: 'var(--color-neutral-100)'
    }
  },
  cellSelected: {
    background: 'var(--color-primary-100)',
    outline: '2px solid var(--color-primary-500)',
    '&:hover': {
      background: 'var(--color-primary-100)'
    }
  },
  label: {
    fontSize: '0.625rem',
    color: 'var(--text-color-subtle)',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%'
  }
}))

function IconPickerGrid ({ value, onSelect }) {
  const classes = useStyles()
  const [search, setSearch] = useState('')

  const filtered = useMemo(() => {
    if (!search.trim()) return allIconNames
    const term = search.toLowerCase()
    return allIconNames.filter(name => name.toLowerCase().includes(term))
  }, [search])

  return (
    <div className={classes.root}>
      <SydInput
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder='Search icons...'
      />
      <div className={classes.grid}>
        {filtered.map(name => (
          <div
            key={name}
            className={`${classes.cell} ${value === name ? classes.cellSelected : ''}`}
            onClick={() => onSelect(name)}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onSelect(name)
              }
            }}
            title={name}
          >
            <Icon name={name} customSize='24px' />
            <span className={classes.label}>{name}</span>
          </div>
        ))}
        {filtered.length === 0 && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '16px', color: 'var(--text-color-subtle)', fontSize: '0.875rem' }}>
            No icons match &quot;{search}&quot;
          </div>
        )}
      </div>
    </div>
  )
}

IconPickerGrid.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired
}

export default IconPickerGrid
